import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/runner/work/cat-app/cat-app/node_modules/@anu-its/ts-react-components/dist/index.esm.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/cat-app/cat-app/node_modules/next/dist/client/image-component.js");
